module.exports = __webpack_public_path__ + "img/phones-md@2x.459920c5.png";